<template>
  <div :class="[
    'py-3 px-3 sm:px-4 w-full animate-slide-down',
    dark ? 'bg-zinc-800 text-white' : 'bg-amber-500 text-black'
  ]">
    <div class="container mx-auto max-w-7xl flex items-start justify-between">
      <div class="flex flex-1 mr-2">
        <font-awesome-icon icon="exclamation-circle" :class="[
          'mr-2 flex-shrink-0 mt-1',
          dark ? 'text-[#09c6f8]' : 'text-amber-800'
        ]" />
        <div class="font-medium text-sm sm:text-base pr-1">{{ message }}</div>
      </div>
      <button 
        v-if="showCloseButton"
        @click="$emit('close')" 
        :class="[
          'transition-colors focus:outline-none ml-1 sm:ml-4 flex-shrink-0 mt-1',
          dark ? 'text-white hover:text-gray-300' : 'text-black hover:text-amber-800'
        ]"
        aria-label="Close alert"
      >
        <font-awesome-icon icon="times" />
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AlertBanner',
  props: {
    message: {
      type: String,
      required: true,
      default: 'Важное сообщение для наших пользователей!'
    },
    dark: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  emits: ['close']
})
</script>

<style scoped>
.animate-slide-down {
  animation: slideDown 0.5s ease-in-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
